import React from "react";
import styles from "./styles.module.scss";

const ParentPath = ({ parent }) => {
  const path = `${parent} > `.replace("/", " > ");
  return <span className={styles.parentPath}>{path}</span>;
};

export default ParentPath;
